import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent {
  /**
   * Show Avatar
   */
  @Input() showAvatar: boolean = false;

  /**
   * Avatar First Name
   */
  @Input() avatarFirstName: string = '';

  /**
   * Avatar Last Name
   */
  @Input() avatarLastName: string = '';

  /**
   * Title
   */
  @Input() title: string = '';

  /**
   * Subtitle
   */
  @Input() subTitle: string = '';
  /**
   * Redirect clicking the subtitle
   */
  @Input() subTitleRedirect: string = '';

  /**
   * Show tabs
   */
  @Input() useTabs: boolean = false;

}
